<template>
  <!-- 此模块为疫情海报弹框 -->
  <div class="es-dialog">
    <van-popup v-model="showDialog" :close-on-click-overlay="false">
      <div class="content">
        <img class="poster-img" src="../../../assets/images/download/es-poster.png" alt="" srcset="">
        <div class="close-box" @click="closeDialog">
          <img class="poster-close-icon" src="../../../assets/images/download/close-es-poster.png" alt="">
        </div>
      </div>
    </van-popup>
    <!-- <footer v-if="showDialog" class="bottom flex" style="z-index: 2017">
      <div class="download" @click="preserveBtn">
        <img src="../../../assets/images/download/download-es-postericon.png" alt="" srcset="">
        <div class="title">保存并分享</div>
      </div>
    </footer> -->
  </div>
</template>

<script>
import { Toast } from 'vant'
export default {
  props: {},
  data() {
    return {
      showDialog: false,
    };
  },
  computed: {},
  components: {},
  created() {},
  mounted() {},
  watch: {},
  methods: {
    /**
     *
     *
     * 显示疫情海报组件
    */
    showPopup () {
      this.showDialog = true
    },
    /**
     *
     *
     * 关闭弹框通知父组件
    */
    closeDialog() {
      this.showDialog = false
      this.$emit('close')
    },
    /**
     *
     *
     * 保存图片到本地
    */
    preserveBtn() {
      const href = 'https://yunlsp-1254176987.cos.ap-shanghai.myqcloud.com/vehicle/es-poster.png'
      const download = 'es-poster' //图片名
      console.log(href)
      this.downloadIamge(href, download)
    },
    downloadIamge(imgsrc, name) {//下载图片地址和图片名
      let image = new Image();
      // 解决跨域 Canvas 污染问题
      image.setAttribute('crossOrigin', 'anonymous');
      image.onload = function() {
        let canvas = document.createElement('canvas');
        canvas.width = image.width
        canvas.height = image.height
        let context = canvas.getContext('2d')
        context.drawImage(image, 0, 0, image.width, image.height)
        let url = canvas.toDataURL('image/png') //得到图片的base64编码数据
        let a = document.createElement('a') // 生成一个a元素
        let event = new MouseEvent('click') // 创建一个单击事件
        a.download = name || 'photo' // 设置图片名称
        a.href = url // 将生成的URL设置为a.href属性
        a.dispatchEvent(event) // 触发a的单击事件
      }
      image.src = imgsrc
      this.showDialog = false
      Toast('已保存至相册，可至朋友圈分享')
      this.$emit('down')
    }
  }
};
</script>

<style scoped lang="scss">
.es-dialog>:first-child {
  background-color: rgba(0,0,0,.4)
}
.es-dialog>:nth-child(2) {
  width: 80%;
  top: 50%;
  background-color: transparent;
}
.es-dialog {
  .content {
    padding: 30px 30px;
    .poster-img {
      width: 100%;
    }
    .close-box {
      text-align: center;
      padding-top: 60px;
      .poster-close-icon {
        width: 52px;
      }
    }
  }
  .bottom {
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100%;
    height: 193px;
    background:rgba(255,255,255,1);
    border-radius:20px 20px 0px 0px;
    justify-content: center;
    align-items: center;
    .download {
      img {
        width: 90px;
        padding-left: 12px;
      }
      .title {
        color: #282828;
        font-size: 20px;
        padding-top: 10px;
      }
    }
  }
}
</style>
